import { render, staticRenderFns } from "./AgentsTab.vue?vue&type=template&id=0c66e5bf&scoped=true&"
import script from "./AgentsTab.vue?vue&type=script&lang=js&"
export * from "./AgentsTab.vue?vue&type=script&lang=js&"
import style0 from "./AgentsTab.vue?vue&type=style&index=0&id=0c66e5bf&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c66e5bf",
  null
  
)

export default component.exports